// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__282Zh","notes":"Notes_notes__UkvWn"};